import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0F1C2E] text-white py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-10">
          {/* Brand */}
          <div className="max-w-xs">
            <img
              src="https://static.readdy.ai/image/00aed269fb1e179199d0d5bf56fc46fa/c2bfb347a213c254cb30dae5f99299d3.png"
              alt="SG SMART GEO 로고"
              className="h-10 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-white/50 text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
              AI 기반 지반 데이터 분석 및 스마트 계측 전문기업
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-10">
            <div>
              <h4 className="text-xs font-semibold text-white/40 tracking-widest uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>Menu</h4>
              <ul className="flex flex-col gap-2">
                {[{ label: '홈', path: '/' }, { label: '솔루션', path: '/solution' }, { label: '문의하기', path: '/contact' }].map(link => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-white/60 hover:text-[#E8521A] transition-colors duration-200 whitespace-nowrap" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-white/40 tracking-widest uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>Contact</h4>
              <ul className="flex flex-col gap-2">
                <li className="flex items-center gap-2 text-sm text-white/60" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                  <i className="ri-mail-line text-[#E8521A]" />
                  sg16588@naver.com
                </li>
                <li className="flex items-center gap-2 text-sm text-white/60" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
                  <i className="ri-phone-line text-[#E8521A]" />
                  054-901-1214
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/30 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            © 2026 주식회사 에스지 (SG SMART GEO). All rights reserved.
          </p>
          <p className="text-white/20 text-xs" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
            사업자등록번호: 000-00-00000
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
